import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DetailViewModule } from '@ui/shared/ui-detail-view';
import type { PreventionListItemModel } from '../definitions/prevention-list-item.model';

@Component({
    selector: 'ui-prevention-details-audience',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DetailViewModule],
    templateUrl: './prevention-details-audience.component.html',
})
export class PreventionDetailsAudienceComponent {
    public mapItem = input.required<PreventionListItemModel>();
}
